'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  margin: 0.5em;\n  padding: 0.5em;\n  height: 7em;\n'], ['\n  position: relative;\n  margin: 0.5em;\n  padding: 0.5em;\n  height: 7em;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  counter-reset: step;\n\n  li {\n    list-style-type: none;\n    width: 25%;\n    float: left;\n    font-size: 12px;\n    position: relative;\n    text-align: center;\n    text-transform: uppercase;\n    color: ', ';\n\n    &:before {\n      width: 35px;\n      height: 35px;\n      content: counter(step);\n      counter-increment: step;\n      line-height: 33px;\n      display: block;\n      text-align: center;\n      margin: 0 auto 10px auto;\n      border-radius: 50%;\n      border: 2px solid ', ';\n      background-color: ', ';\n      color: ', ';\n    }\n\n    &:after {\n      width: 100%;\n      height: 2px;\n      content: \'\';\n      position: absolute;\n      background-color: ', ';\n      top: 15px;\n      left: -50%;\n      z-index: -1;\n    }\n\n    &:first-child:after {\n      content: none;\n    }\n\n    &.active:before {\n      color: ', ';\n      border-color: ', ';\n      background-color: ', ';\n    }\n\n    &.active + li:after {\n      background-color: ', ';\n    }\n  }\n'], ['\n  counter-reset: step;\n\n  li {\n    list-style-type: none;\n    width: 25%;\n    float: left;\n    font-size: 12px;\n    position: relative;\n    text-align: center;\n    text-transform: uppercase;\n    color: ', ';\n\n    &:before {\n      width: 35px;\n      height: 35px;\n      content: counter(step);\n      counter-increment: step;\n      line-height: 33px;\n      display: block;\n      text-align: center;\n      margin: 0 auto 10px auto;\n      border-radius: 50%;\n      border: 2px solid ', ';\n      background-color: ', ';\n      color: ', ';\n    }\n\n    &:after {\n      width: 100%;\n      height: 2px;\n      content: \'\';\n      position: absolute;\n      background-color: ', ';\n      top: 15px;\n      left: -50%;\n      z-index: -1;\n    }\n\n    &:first-child:after {\n      content: none;\n    }\n\n    &.active:before {\n      color: ', ';\n      border-color: ', ';\n      background-color: ', ';\n    }\n\n    &.active + li:after {\n      background-color: ', ';\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var ProgressBar = _styledComponents2.default.ul(_templateObject2, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.white, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.white, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.blue_accent);

var getSteps = function getSteps(data, current) {
  var DATA = [];
  var style = { width: Math.floor(100 / data.length) + '%' };
  var curIndex = data.indexOf(current);
  if (data.length > 0) {
    data.forEach(function (step, index) {
      DATA.push(_react2.default.createElement(
        'li',
        { style: style, className: index <= curIndex ? 'active' : 'nonactive' },
        step
      ));
    });
  }
  return DATA;
};

var MozartProgressStep = function MozartProgressStep(props) {
  var data = props.data,
      style = props.style,
      current = props.current,
      themeId = props.themeId;

  return _react2.default.createElement(
    Container,
    { style: style, 'data-qa': props.testId, 'data-theme': themeId },
    data.length > 0 && _react2.default.createElement(
      ProgressBar,
      null,
      getSteps(data, current)
    )
  );
};

MozartProgressStep.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  data: _propTypes2.default.array.isRequired,
  current: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.number])
};

MozartProgressStep.defaultProps = {
  style: {},
  data: [],
  current: 1,
  testId: 'MozartProgressStep',
  themeId: 'MozartProgressStep'
};

exports.default = MozartProgressStep;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartProgressStep/MozartProgressStep.js
// module id = 1837
// module chunks = 1